module.exports = __webpack_public_path__ + "img/qrCode_zhCn.d3464ddb.png";